import React from 'react';
import Box from '@mui/material/Box';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import Typography from '@mui/material/Typography'

export default function CompareSlider({ height, imageSet, dayShow }) {
    return (
        <Box position={'relative'}>
            {
                dayShow &&
                <Box position={'absolute'} top={13} left={15} zIndex={2}>
                    <Typography variant="body1" color='#FFF'>Before</Typography>
                </Box>
            }
            
            <Box
                component={ReactCompareSlider}
                sx={{ height: height ?? 'auto', width: '100%' }}
                itemOne={
                    <Box
                        component={ReactCompareSliderImage}
                        src={imageSet.before}
                        alt="Before"
                        sx={{ objectFit: 'fill !important', width: '100%' }}
                    />
                }
                itemTwo={
                    <Box
                        component={ReactCompareSliderImage}
                        src={imageSet.after}
                        alt="After"
                        sx={{ objectFit: 'fill !important', width: '100%' }}
                    />
                }
            />
            {
                dayShow &&
                <Box position={'absolute'} top={13} right={15} zIndex={2}>
                    <Typography variant="body1" color='#FFF'>After</Typography>
                </Box>
            }
        </Box>
    );
}
